<template>
    <h3 v-html="text.estimateDetailsTitle"></h3>
    <h4>
      <span v-html="text.mortgagePayoffTitle"></span>
      <span class="badge badge-yellow" v-if="product.totalAvailableProceeds >= 0">{{toCurrency(product.mortgagePayoff)}}</span>
      <span class="badge badge-yellow" v-if="product.totalAvailableProceeds < 0">{{toCurrency(product.principalLimit)}}</span>
    </h4>
    <p v-html="text.mortgagePayoffText"></p>
    <h4 v-if="product.totalAvailableProceeds >= 0">
      <span v-html="text.totalAvailableProceedsTitle"></span>
      <span class="badge badge-green">{{toCurrency(product.totalAvailableProceeds)}}</span>
    </h4>
    <p v-if="product.totalAvailableProceeds >= 0" v-html="doShortcode(text.totalAvailableProceedsText)"></p>
    <h4>
      <span v-html="text.equityReserveTitle"></span>
      <span class="badge badge-blue">{{toCurrency(product.equityReserve)}}</span>
    </h4>
    <p v-html="doShortcode(text.equityReserveText)"></p>
    <div class="short-to-close-details" v-if="product.totalAvailableProceeds < 0">
      <h4>
        <span v-html="text.borrowerMortgagePayoffTitle"></span>
        <span class="badge badge-green">{{toCurrency(product.totalAvailableProceeds)}}</span>
      </h4>
      <p v-html="text.borrowerMortgagePayoffText"></p>
    </div>
    <hr />
    <h3 v-html="text.productBenefitsTitle"></h3>
    <ul v-for="(benefit, index) in text.productBenefits" :key="`benefit-${index}`">
      <li v-if="doShortcode(benefit) !== false" v-html="doShortcode(benefit)"></li>
    </ul>
    <hr />
    <div class="product-footnotes" v-html="doShortcode(text.productFootnotes)"></div>
</template>

<script>

import { defineComponent } from 'vue'
import { currencyConversion } from '../inc/helpers.js'
export default defineComponent({
  name: 'ProductDetails',
  inheritAttrs: false,
  props: {
    product: Object,
    youngestBorrower: Number,
    creditGrowth: Number,
    textStrings: Object
  },
  methods: {
    toCurrency (val) {
      return currencyConversion(Math.abs(val))
    },
    doShortcode (templateString) {
      let showShortcode = true
      const shortcodes = {
        totalAvailableDayOne: this.toCurrency(this.product.totalAvailableDayOne),
        totalAvailableMonthTwelve: this.toCurrency(this.product.totalAvailableAfterTwelveMonths),
        creditGrowthAge: (~~this.youngestBorrower + 20),
        creditGrowth: this.toCurrency(this.creditGrowth)
      }
      const templatedKeys = Object.keys(shortcodes).map((item) => {
        return '{{' + item + '}}'
      })

      const regex = new RegExp(templatedKeys.join('|'), 'gi')

      const hydratedString = templateString.replace(regex, function (match) {
        if (shortcodes[match.slice(2, match.length - 2)] === '$NaN') {
          showShortcode = false
        }
        console.log('shortcodes: ' + shortcodes[match.slice(2, match.length - 2)])
        return shortcodes[match.slice(2, match.length - 2)]
      })
      if (showShortcode === false) {
        return false
      }
      return hydratedString
    }
  },
  data () {
    if (this.product.totalAvailableProceeds < 0) {
      return {
        text: this.textStrings.hecmShortToClose
      }
    }
    return {
      text: this.textStrings[this.product.id]
    }
  }
})
</script>
